module.exports = __webpack_public_path__ + "ui-static/img/export-border-left.1e291203.svg";